// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sectionTwo-wrapper {
  width: 100%;
  height: auto;
  background: rgba(231, 176, 81, 0.25);
  padding: 80px 180px;
}
#sectionTwo-wrapper #sectionTwo {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  align-items: center;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-head {
  font-family: Roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 43px;
  line-height: 134.19%;
  margin-bottom: 30px;
  padding: 0;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card {
  padding: 25px 10px;
  height: 376px;
  width: 100%;
  grid-gap: 5%;
  gap: 6%;
  margin-top: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #sectionTwo-card-1 {
  width: 35%;
  height: 350px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #sectionTwo-card-2 {
  width: 35%;
  height: 350px;
  background: #fff;
  padding: 20px;
  border-radius: 10px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #sectionTwo-card-3 {
  width: 26%;
  height: 300px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #sectionTwo-card-1-top, #sectionTwo-wrapper #sectionTwo #sectionTwo-card #sectionTwo-card-2-top {
  display: flex;
  align-items: center;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-1-icon,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-2-icon,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-3-icon {
  width: 30px;
  margin-right: 20px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-1-head1,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-2-head1,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-3-head1 {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 20px;
  text-transform: capitalize;
  color: #1C2640;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-1-head2,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-2-head2,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-3-head2 {
  font-style: normal;
  font-weight: bold;
  font-size: 21px;
  line-height: 20px;
  text-transform: capitalize;
  color: #1c2640;
  margin-top: 2%;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-1-para,
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-3-para {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #1c2640;
  margin-top: 25px;
  padding: 10px 50px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-card #card-2-para {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #1c2640;
  padding: 25px 0px 25px 50px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-ctas {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 40px;
}
#sectionTwo-wrapper #sectionTwo #sectionTwo-ctas button {
  text-align: center;
  padding: 10px 30px;
  height: 40px;
  border: none;
  color: white;
  background: #ec6927;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  cursor: pointer;
  font-weight: bold;
  font-family: sans-serif;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  margin: 0 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/SectionTwo/sectionTwo.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,oCAAA;EACA,mBAAA;AACD;AACC;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EAEA,mBAAA;AAAF;AAGE;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;AADH;AAIE;EACC,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;AAFH;AAIG;EACC,UAAA;EACG,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAFP;AAIG;EACC,UAAA;EACG,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAFP;AAIG;EACC,UAAA;EACA,aAAA;AAFJ;AAKG;EACI,aAAA;EACA,mBAAA;AAHP;AAMG;;;EAGC,WAAA;EACA,kBAAA;AAJJ;AAOG;;;EAGC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;AALJ;AAQG;;;EAGC,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,cAAA;EACA,cAAA;AANJ;AASG;;EAEC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAPJ;AAWG;EACC,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,2BAAA;AATJ;AAcE;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAZH;AAcG;EACC,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,2CAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;AAZJ","sourcesContent":["#sectionTwo-wrapper {\n\twidth: 100%;\n\theight: auto;\n\tbackground: rgba(231, 176, 81, 0.25);\n\tpadding: 80px 180px;\n\n\t#sectionTwo {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\twidth: 100%;\n\t\tposition: relative;\n\t\t// max-width: 1240px;\n\t\talign-items: center;\n\t\t\n\n\t\t#sectionTwo-head {\n\t\t\tfont-family: Roboto;\n\t\t\tfont-style: normal;\n\t\t\tfont-weight: 400;\n\t\t\tfont-size: 43px;\n\t\t\tline-height: 134.19%;\n\t\t\tmargin-bottom: 30px;\n\t\t\tpadding: 0;\n\t\t}\n\n\t\t#sectionTwo-card {\n\t\t\tpadding: 25px 10px;\n\t\t\theight: 376px;\n\t\t\twidth: 100%;\n\t\t\tgrid-gap: 5%;\n\t\t\tgap: 6%;\n\t\t\tmargin-top: 40px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\n\t\t\t#sectionTwo-card-1 {\n\t\t\t\twidth: 35%;\n\t\t\t    height: 350px;\n\t\t\t    background: #fff;\n\t\t\t    padding: 20px;\n\t\t\t    border-radius: 10px;\n\t\t\t}\n\t\t\t#sectionTwo-card-2 {\n\t\t\t\twidth: 35%;\n\t\t\t    height: 350px;\n\t\t\t    background: #fff;\n\t\t\t    padding: 20px;\n\t\t\t    border-radius: 10px;\n\t\t\t}\n\t\t\t#sectionTwo-card-3 {\n\t\t\t\twidth: 26%;\n\t\t\t\theight: 300px;\n\t\t\t}\n\n\t\t\t#sectionTwo-card-1-top , #sectionTwo-card-2-top {\n\t\t\t    display: flex;\n\t\t\t    align-items: center;\n\t\t\t}\n\n\t\t\t#card-1-icon,\n\t\t\t#card-2-icon,\n\t\t\t#card-3-icon {\n\t\t\t\twidth: 30px;\n\t\t\t\tmargin-right: 20px;\n\t\t\t}\n\n\t\t\t#card-1-head1,\n\t\t\t#card-2-head1,\n\t\t\t#card-3-head1 {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: 500;\n\t\t\t\tfont-size: 18px;\n\t\t\t\tline-height: 20px;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t\tcolor: #1C2640;\n\t\t\t}\n\n\t\t\t#card-1-head2,\n\t\t\t#card-2-head2,\n\t\t\t#card-3-head2 {\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-size: 21px;\n\t\t\t\tline-height: 20px;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t\tcolor: #1c2640;\n\t\t\t\tmargin-top: 2%;\n\t\t\t}\n\n\t\t\t#card-1-para,\n\t\t\t#card-3-para {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 19px;\n\t\t\t\tcolor: #1c2640;\n\t\t\t\tmargin-top: 25px;\n\t\t\t\tpadding: 10px 50px;\n\t\t\t\t// text-transform: capitalize;\n\t\t\t}\n\n\t\t\t#card-2-para {\n\t\t\t\tfont-family: Roboto;\n\t\t\t\tfont-style: normal;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 19px;\n\t\t\t\tcolor: #1c2640;\n\t\t\t\tpadding: 25px 0px 25px 50px;\n\t\t\t\t// text-transform: capitalize;\n\t\t\t}\n\t\t}\n\n\t\t#sectionTwo-ctas {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\tjustify-content: center;\n\t\t\tmargin-top: 40px;\n\n\t\t\tbutton {\n\t\t\t\ttext-align: center;\n\t\t\t\tpadding: 10px 30px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder: none;\n\t\t\t\tcolor: white;\n\t\t\t\tbackground: #ec6927;\n\t\t\t\tbox-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tcursor: pointer;\n\t\t\t\tfont-weight: bold;\n\t\t\t\tfont-family: sans-serif;\n\t\t\t\tfont-size: 100%;\n\t\t\t\tline-height: 1.15;\n\t\t\t\tmargin: 0;\n\t\t\t\tmargin: 0 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
